import { render } from "./DomainInput.vue?vue&type=template&id=41be9d10&ts=true"
import script from "./DomainInput.vue?vue&type=script&lang=ts"
export * from "./DomainInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__